import React, { useState } from 'react';
import { ArrowLeftIcon, SaveIcon, MapPinIcon, FileTextIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function CreateRecordPage({
  navigateTo
}: {
  navigateTo: (page: string) => void;
}) {
  const {
    language,
    t
  } = useLanguage();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      navigateTo('myPlots');
    }, 1500);
  };
  return <div className="max-w-3xl mx-auto space-y-6 pb-10" data-id="element-764">
      <button onClick={() => navigateTo('myPlots')} className="flex items-center text-sm font-medium text-gray-500 hover:text-[#006A4E] transition-colors" data-id="element-765">
        <ArrowLeftIcon className="w-4 h-4 mr-1" data-id="element-766" />{' '}
        {language === 'bn' ? 'ফিরে যান' : 'Back to My Plots'}
      </button>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-767">
        <div className="bg-[#006A4E] px-6 py-4 flex items-center text-white" data-id="element-768">
          <FileTextIcon className="w-6 h-6 mr-3 text-[#C9A84C]" data-id="element-769" />
          <h1 className="text-xl font-bold" data-id="element-770">
            {t('createRecord') || 'Create New Record'}
          </h1>
        </div>

        <form onSubmit={handleSubmit} className="p-6 md:p-8 space-y-8" data-id="element-771">
          {/* Location Details */}
          <div data-id="element-772">
            <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center border-b border-gray-100 pb-2" data-id="element-773">
              <MapPinIcon className="w-5 h-5 mr-2 text-[#006A4E]" data-id="element-774" />
              {t('locationInfo') || 'Location Information'}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-775">
              <div data-id="element-776">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-777">
                  {t('district')}
                </label>
                <select className="w-full border border-gray-300 rounded-lg py-2.5 px-3 focus:ring-2 focus:ring-[#006A4E] focus:border-[#006A4E] outline-none transition-shadow" required data-id="element-778">
                  <option value="" data-id="element-779">Select District</option>
                  <option value="Dhaka" data-id="element-780">Dhaka</option>
                  <option value="Gazipur" data-id="element-781">Gazipur</option>
                  <option value="Narsingdi" data-id="element-782">Narsingdi</option>
                </select>
              </div>
              <div data-id="element-783">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-784">
                  {t('upazila')}
                </label>
                <select className="w-full border border-gray-300 rounded-lg py-2.5 px-3 focus:ring-2 focus:ring-[#006A4E] focus:border-[#006A4E] outline-none transition-shadow" required data-id="element-785">
                  <option value="" data-id="element-786">Select Upazila</option>
                  <option value="Kaliganj" data-id="element-787">Kaliganj</option>
                  <option value="Shibpur" data-id="element-788">Shibpur</option>
                </select>
              </div>
              <div data-id="element-789">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-790">
                  {t('mouza')}
                </label>
                <select className="w-full border border-gray-300 rounded-lg py-2.5 px-3 focus:ring-2 focus:ring-[#006A4E] focus:border-[#006A4E] outline-none transition-shadow" required data-id="element-791">
                  <option value="" data-id="element-792">Select Mouza</option>
                  <option value="Jamalpur" data-id="element-793">Jamalpur</option>
                  <option value="Putia" data-id="element-794">Putia</option>
                </select>
              </div>
            </div>
          </div>

          {/* Record Details */}
          <div data-id="element-795">
            <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center border-b border-gray-100 pb-2" data-id="element-796">
              <FileTextIcon className="w-5 h-5 mr-2 text-[#006A4E]" data-id="element-797" />
              {t('khatianDetails') || 'Record Details'}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-798">
              <div data-id="element-799">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-800">
                  {t('khatian')} No.
                </label>
                <input type="text" className="w-full border border-gray-300 rounded-lg py-2.5 px-3 focus:ring-2 focus:ring-[#006A4E] focus:border-[#006A4E] outline-none transition-shadow" placeholder="e.g. 1023" required data-id="element-801" />
              </div>
              <div data-id="element-802">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-803">
                  {t('dag')} No.
                </label>
                <input type="text" className="w-full border border-gray-300 rounded-lg py-2.5 px-3 focus:ring-2 focus:ring-[#006A4E] focus:border-[#006A4E] outline-none transition-shadow" placeholder="e.g. 456" required data-id="element-804" />
              </div>
              <div data-id="element-805">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-806">
                  {t('landType')}
                </label>
                <select className="w-full border border-gray-300 rounded-lg py-2.5 px-3 focus:ring-2 focus:ring-[#006A4E] focus:border-[#006A4E] outline-none transition-shadow" required data-id="element-807">
                  <option value="" data-id="element-808">Select Type</option>
                  <option value="agricultural" data-id="element-809">{t('agricultural')}</option>
                  <option value="residential" data-id="element-810">{t('residential')}</option>
                  <option value="commercial" data-id="element-811">{t('commercial')}</option>
                </select>
              </div>
              <div data-id="element-812">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-813">
                  {t('area')} (Decimals)
                </label>
                <input type="number" step="0.01" className="w-full border border-gray-300 rounded-lg py-2.5 px-3 focus:ring-2 focus:ring-[#006A4E] focus:border-[#006A4E] outline-none transition-shadow" placeholder="e.g. 45.5" required data-id="element-814" />
              </div>
              <div className="md:col-span-2" data-id="element-815">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-816">
                  {t('ownershipType')}
                </label>
                <div className="flex space-x-6 mt-2" data-id="element-817">
                  <label className="flex items-center space-x-2 cursor-pointer" data-id="element-818">
                    <input type="radio" name="ownership" value="sole" className="w-4 h-4 text-[#006A4E] focus:ring-[#006A4E]" defaultChecked data-id="element-819" />
                    <span className="text-gray-700" data-id="element-820">{t('sole') || 'Sole'}</span>
                  </label>
                  <label className="flex items-center space-x-2 cursor-pointer" data-id="element-821">
                    <input type="radio" name="ownership" value="joint" className="w-4 h-4 text-[#006A4E] focus:ring-[#006A4E]" data-id="element-822" />
                    <span className="text-gray-700" data-id="element-823">
                      {t('joint') || 'Joint'}
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-6 border-t border-gray-200 flex justify-end space-x-4" data-id="element-824">
            <button type="button" onClick={() => navigateTo('myPlots')} className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg font-bold hover:bg-gray-50 transition-colors" data-id="element-825">
              {t('cancel')}
            </button>
            <button type="submit" disabled={isSubmitting} className="px-6 py-2.5 bg-[#006A4E] text-white rounded-lg font-bold hover:bg-[#004D3A] transition-colors shadow-md flex items-center disabled:opacity-70" data-id="element-826">
              {isSubmitting ? 'Saving...' : <>
                  <SaveIcon className="w-5 h-5 mr-2" data-id="element-827" />
                  {t('save')}
                </>}
            </button>
          </div>
        </form>
      </div>
    </div>;
}